import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import FlagIcon from '@mui/icons-material/Flag';
import ReportModal from './ReportModal';
import api from '../../services/api';
import API from '../config';

export default function ReportButton({ reviewId, onReported, disabled = false, isOwnReview = false }) {
  const [open, setOpen] = useState(false);
  const [reported, setReported] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    if (isOwnReview) {
      return; // Don't allow flagging own review
    }
    if (!disabled && !reported) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (reason, details) => {
    if (!reviewId) {
      alert('Error: Review ID is missing. Please refresh the page and try again.');
      return;
    }
    
    setLoading(true);
    try {
      console.log('[ReportButton] Flagging review with ID:', reviewId);
      const response = await api.post(`${API}/api/reviews/${reviewId}/flag`, {
        reason,
        details
      });

      if (response.status === 201) {
        setReported(true);
        setOpen(false);
        if (onReported) {
          onReported();
        }
        // Show success message (you might want to use a toast notification here)
        console.log('Review reported successfully');
      }
    } catch (error) {
      console.error('Error reporting review:', error);
      
      // Handle specific error cases
      if (error.response) {
        if (error.response.status === 409) {
          // Already reported
          setReported(true);
          alert('You have already reported this review.');
        } else if (error.response.status === 400 && error.response.data?.error?.includes('cannot flag your own')) {
          alert('You cannot flag your own review.');
        } else if (error.response.status === 401) {
          alert('Please log in to report reviews.');
        } else {
          alert(error.response.data?.error || 'Failed to report review. Please try again.');
        }
      } else {
        alert('Network error. Please check your connection and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  // Don't show button if it's the user's own review
  if (isOwnReview) {
    return null;
  }

  return (
    <>
      <Tooltip title={reported ? "Already reported" : "Report this review"}>
        <span>
          <IconButton
            onClick={handleOpen}
            disabled={disabled || reported}
            size="small"
            sx={{
              color: reported 
                ? 'text.disabled' 
                : (theme) => alpha(theme.palette.error.main, 0.7),
              '&:hover': {
                color: (theme) => theme.palette.error.main,
                backgroundColor: (theme) => alpha(theme.palette.error.main, 0.1),
              },
              opacity: reported ? 0.5 : 1,
            }}
          >
            <FlagIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      
      <ReportModal
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        loading={loading}
      />
    </>
  );
}

